import { Box, Button, Typography } from "@material-ui/core";

const HOSTED_FORM_ORIGIN_HOST = "medlearnity.activehosted.com";
// Exactly /f/<positive decimal integer>: no leading zeros, no extra segments,
// no trailing slash.
const HOSTED_FORM_PATH_PATTERN = /^\/f\/[1-9][0-9]*$/;

// Returns the configured hosted-form URL only when every rule holds; any
// parse error or mismatch fails dark with null so the CTA never renders
// against an unexpected destination.
const sanitizeHostedFormUrl = (rawUrl) => {
  if (typeof rawUrl !== "string" || rawUrl.length === 0) return null;
  // The contract allows no query or fragment delimiter at all, but a bare
  // trailing "?" or "#" survives WHATWG parsing with empty search/hash getters
  // and round-trips through href, so the ban is enforced on the raw string.
  if (rawUrl.includes("?") || rawUrl.includes("#")) return null;
  let parsed;
  try {
    parsed = new URL(rawUrl);
  } catch (_) {
    return null;
  }
  if (parsed.protocol !== "https:"
      || parsed.hostname !== HOSTED_FORM_ORIGIN_HOST
      || parsed.port !== ""
      || parsed.username !== ""
      || parsed.password !== ""
      || parsed.search !== ""
      || parsed.hash !== ""
      || !HOSTED_FORM_PATH_PATTERN.test(parsed.pathname)
      // The canonical serialization must equal the configured value, so an
      // explicit ":443", stray whitespace, or case tricks that the URL parser
      // normalizes away are rejected rather than silently repaired.
      || parsed.href !== rawUrl) {
    return null;
  }
  return parsed.href;
};

// Optional post-answer CTA to ActiveCampaign's native hosted double-opt-in
// form. QLearn only links out: the provider owns form entry, consent
// confirmation, subscription, suppression, and unsubscribe.
export default function WeeklyAbsiteSignup() {
  if (process.env.REACT_APP_WEEKLY_ABSITE_SIGNUP_ENABLED !== "true") return null;
  const hostedFormUrl = sanitizeHostedFormUrl(process.env.REACT_APP_WEEKLY_ABSITE_SIGNUP_URL);
  if (!hostedFormUrl) return null;

  return (
    <Box className="weekly-absite-signup" data-testid="weekly-absite-signup">
      <Typography variant="subtitle1">Get one free ABSITE case each week.</Typography>
      <Typography variant="body2">
        Choose whether to subscribe on the next page. You can unsubscribe at any time.
      </Typography>
      <Button
        color="primary"
        component="a"
        href={hostedFormUrl}
        rel="noopener noreferrer"
        target="_blank"
        variant="outlined"
      >
        Get a weekly ABSITE case
      </Button>
    </Box>
  );
}
